import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

interface SessionDisconnectedDialogProps {
  open: boolean;
}

export function SessionDisconnectedDialog({ open }: SessionDisconnectedDialogProps) {
  const navigate = useNavigate();

  const handleChangePassword = () => {
    navigate("/forgot-password");
  };

  const handleAcknowledge = async () => {
    await supabase.auth.signOut();
    navigate("/auth", { replace: true });
  };

  return (
    <AlertDialog open={open}>
      <AlertDialogContent
        className="sm:max-w-md"
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <AlertDialogHeader>
          <div className="flex justify-center mb-4">
            <div className="h-14 w-14 rounded-full bg-destructive/10 flex items-center justify-center">
              <ShieldAlert className="h-7 w-7 text-destructive" />
            </div>
          </div>
          <AlertDialogTitle className="text-center">
            Sessão encerrada
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center space-y-2">
            <span className="block">
              Alguém fez login na sua conta de outro dispositivo.
            </span>
            <span className="block text-destructive font-medium">
              Se não foi você, troque sua senha imediatamente.
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            variant="destructive"
            onClick={handleChangePassword}
            className="w-full sm:w-auto"
          >
            Alterar Senha
          </Button>
          <Button
            variant="outline"
            onClick={handleAcknowledge}
            className="w-full sm:w-auto"
          >
            Entendi
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
